import { isValidUrl } from './is-valid-url';

export const openUrl = (url: string): void => {
  // Open the URL in a new tab with added security
  // To prevent window.opener phishing attacks
  // https://developer.mozilla.org/en-US/docs/Web/API/Window/opener#value

  if (!isValidUrl(url)) {
    console.error('Invalid redirectUrl:', url);
    return;
  }

  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.target = '_blank';
  // `noopener` blocks window.opener tab-nabbing. `noreferrer` is intentionally
  // omitted so the Referer header reaches our own UserWay properties (Dashboard,
  // userway.org) for analytics attribution.
  anchor.rel = 'noopener';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
};
